module.exports = __webpack_public_path__ + "assets/6721eae2388b22db3a0771876da9c826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-next.jpg
// module id = 1015
// module chunks = 0